import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/Index.vue'
import { useStore } from '@/store/index'

const store = useStore()

const qualificationRouter: Array<RouteRecordRaw> = [
    {
        path: '/qualification',
        component: Layout,
        name: '资质管理',
        redirect: '/qualification/list',
        meta: { title: '资质管理', icon: 'icon-seal', alwaysShow: true },
        children: [
            {
                path: 'list',
                name: '资质列表',
                // 当登录用户是商户时，直接跳转到编辑页
                // @ts-ignore
                component: () => store.state.user.userInfo.user_type != '2' ? import('@/views/qualification/List.vue') : import('@/views/qualification/Edit.vue'), 
                meta: { title: '资质列表' }
            },
            {
                path: 'edit',
                name: '资质编辑',
                component: () => import('@/views/qualification/Edit.vue'),
                meta: { title: '资质编辑', hidden: true, depth: 40 }
            },
            {
                path: 'check',
                name: '资质审核',
                component: () => import('@/views/qualification/Check.vue'),
                meta: { title: '资质审核', hidden: true, depth: 40, badge: 'certification' }
            },
            {
                path: 'certification-list',
                name: '资质白名单列表',
                component: () => import('@/views/qualification/CertificationList.vue'),
                meta: { title: '白名单'}
            },
            {
                path: 'certificate-log',
                name: '过期下架列表',
                component: () => import('@/views/qualification/CertificateLog.vue'),
                meta: { title: '过期下架列表'}
            },
            {
                path: 'certificate-download',
                name: '资质下载',
                component: () => import('@/views/qualification/CertificateDownload.vue'),
                meta: { title: '资质下载'}
            },
            {
                path: 'owner-certificate-download',
                name: '法人资质下载',
                component: () => import('@/views/qualification/OwnerCertificateDownload.vue'),
                meta: { title: '法人资质下载'}
            },
        ]
    }
]

export default qualificationRouter